import { Period } from '../types';

/**
 * Získa oddeľovač podľa typu periody.
 * @param name - název periody
 * @returns  příslušný oddělovač nebo prázdný řetězec
 */
const getDivider = (name: string): string => {
  if (name === '1OT') {
    return ' - ';
  } else if (name !== '1PER' && name !== '1OT') {
    return ', ';
  }
  return '';
};

/**
 * Aktualizuje obsah HTML elementu 'data-match-overview-score-details-period' pro score jednotlivých period
 *
 * @param element - HTMLElement zápasu, který má být aktualizován. Obashuje HTMLElement s data atributem: 'data-match-overview-score-details-period'.
 * @param periods - objekt obsahující pole period
 */
export const updateMatchScoreDetailsPeriods = (element: HTMLElement | null, periods: Period[]) => {
  if (!element || !periods) return;

  const periodElement = element.querySelector<HTMLElement>(
    '[data-match-overview-score-details-period]'
  );

  if (!periodElement) {
    console.warn(
      `Element s query selector "[data-match-overview-score-details-period]" nebol nájdený.`
    );
    return;
  }

  if (periodElement) {
    const currentResultPeriods = periodElement.getAttribute(
      'data-match-overview-score-details-period'
    );

    const resultText = periods.reduce((acc, period) => {
      if (!period.start_time || period.start_time.trim() === '') {
        return acc;
      }

      const trimmedValue = period.value_colon.trim();
      const divider = getDivider(period.name);
      return acc + divider + trimmedValue;
    }, '');

    if (currentResultPeriods !== resultText) {
      periodElement.textContent = resultText;
      periodElement.setAttribute('data-match-overview-score-details-period', resultText);
    }
  }
};
